export const getAutoPayDescriptions = (selectedPolicy, cardNumber) => {
  if (selectedPolicy?.billingTypeCode === "02") {
    let accountNumber = selectedPolicy?.bankInfo?.bank?.accountNumber;

    let fourDigitAccountNumber = accountNumber?.substring(
      accountNumber.length - 4
    );
    if (cardNumber === fourDigitAccountNumber) return ["Bank Draft", "Account"];
  }
  return ["Credit card", "Card"];
};
